import React from "react";

const OrderField = ({ title, overrideClass, children }) => {

  return (
    <div className={overrideClass || 'order-form__block'}>
      <div className='order-form__block-title'>
        <h2>{title}</h2>
      </div>
      <div className='order-form__block-content-wrap'>
        { children }
      </div>
    </div>
  )
}

export default OrderField;